import _ from 'underscore'

import React from 'react'
import styled from 'styled-components'

import Table from 'components/Table'

import Stage from 'pages/Device/ThermostatRthPanel/GoRthCycles/Stage'
import { OPERATIONS } from 'pages/Device/ThermostatRthPanel/Chart/rthDataParser'

import { Accessories, stage } from 'types/RuntimeHistory'

type props = {
  stages: Record<string, stage>
  accessories : Accessories
  isHehm?: boolean
}

const ACCESSORIES = [
  'DEHUMIDIFIER',
  'HUMIDIFIER',
  'VENTILATOR'
]

// HACK: HEHM devices simulate stage heating and cooling,
// but the firmware does not yet distinguish between stages,
// so the backend always returns "Stage 1" in cycle count descriptions.
// We strip "Stage 1" from the display name since it's misleading.
// If the algorithm team adds stage support this hack can be removed.
const removeStage1FromName = (stage: stage): stage => ({
  ...stage,
  name: stage.name.replace(/ Stage 1$/, '')
})

const toStageArray = (stages: Record<string, stage>): Array<stage> =>
  Object.values(stages).map((s) => {
    const { name, mode, color } = OPERATIONS[s.stage]

    return { ...s, name, mode, color }
  })

const GoRthCycles = ({ stages, isHehm = false }: props) => {
  const stageArray = toStageArray(stages)
  const parsedStages = isHehm ? stageArray.map(removeStage1FromName) : stageArray
  const indoorItemRegex = /(indoor|ids)/i
  const availableAccessories = _.filter(parsedStages, (stage) => (ACCESSORIES.includes(stage.stage) && stage.cycleCount !== 0))
  const outdoorStages = _.filter(parsedStages, (stage) => !OPERATIONS[stage.stage].category.match(indoorItemRegex) && stage.cycleCount !== 0 && !availableAccessories.includes(stage))
  const indoorStages = _.filter(parsedStages, (stage) => OPERATIONS[stage.stage].category.match(indoorItemRegex) && stage.cycleCount !== 0 && !availableAccessories.includes(stage))

  return (
    <S.Cycles aria-label="cycle-count-history">
      <Table items={[Array.from(parsedStages), availableAccessories]} noDataMessage={{ title: '', description: '' }}>
        <Table.Header>
          <S.CycleCountHistoryHeaderCell title="Cycle Count History" />
          <Table.HeaderCell title="Cycle Count" />
          <Table.HeaderCell title="Run Time Mins" />
        </Table.Header>
        <div>
          {!_.isEmpty(outdoorStages) && <S.CategoryRow>Outdoor</S.CategoryRow>}
          {_.map(outdoorStages, (stage) => <Stage key={stage.stage} stage={stage} />)}
          {!_.isEmpty(indoorStages) && <S.CategoryRow>Indoor</S.CategoryRow>}
          {_.map(indoorStages, (stage) => <Stage key={stage.stage} stage={stage} />)}
          {!_.isEmpty(availableAccessories) && <S.CategoryRow>Accessories</S.CategoryRow>}
          {_.map(_.keys(availableAccessories), item => <Stage key={item} stage={availableAccessories[item]} />)}
        </div>
      </Table>
    </S.Cycles>
  )
}

export default GoRthCycles

const S = {
  Cycles: styled.div`
    padding: 20px;
  `,
  CategoryRow: styled(Table.Row)`
    font-weight: bold;
    padding: 10px;
  `,
  CycleCountHistoryHeaderCell: styled(Table.HeaderCell)`
    flex: 2;
  `
}
